/* Skullette ODD LOT SALE — floating cart bar (anh 10-15: no cart drawer on add) with the wallet-offer progress
 * (window.OLOffers, brief §5): last 2 cart photos + count (tap → Horizon drawer) · "2 items · $57.90" · progress line
 * ("Add a wallet for $4 off — from $8.95" / "Add 2 more wallets to save $7" / "You're saving $X") · Checkout →.
 * Below it, while an offer is still open, a one-tap row of 3 wallets: same design as the bags in the cart first
 * (ops matching_wallets), then the shelf's wallet order (ops: high stock first). With a bag slot open the price
 * reads "$8.95 ~~$12.95~~" (the −$4 Shopify applies), otherwise the plain price toward the trio.
 * Also lights the hero offer card that's in play. Repaints from 'sol:added' or Horizon 'cart:update' (drawer
 * edits → debounced GET /cart.js). Saved $ only from cart.total_discount — never estimated. Needs SOL + OLOffers. */
(function () {
  var A = window.SOL, O = window.OLOffers;
  if (!A || !O) return;
  var root = A.root;
  var bar = root.querySelector('[data-sol-bar]');
  if (!bar) return;
  var tEl = bar.querySelector('[data-sol-bar-t]'), addEl = bar.querySelector('[data-sol-bar-add]'), thumbsEl = bar.querySelector('[data-sol-bar-thumbs]');
  var cards = root.querySelectorAll('[data-sol-offers] [data-offer]');
  var timer = null;

  function wallets() { return A.data().filter(function (d) { return d.a && d.g === 'wallet'; }); }
  function walletMin() { var ps = wallets().map(function (d) { return d.p; }); return ps.length ? Math.min.apply(null, ps) : 0; }
  function byHandle(h) { return A.data().filter(function (d) { return d.h === h && d.a; })[0]; }
  function addOnRow(t, st) {
    if (!st.offer || st.offer === 'any') return '';
    var slot = O.bagSlotOpen(t);
    var hs = O.suggest(t, wallets().map(function (d) { return d.h; }), 6);
    var ws = hs.map(byHandle).filter(Boolean).slice(0, 3);
    return ws.length ? '<div class="sol-bar__addons">' + ws.map(function (d) {
      var price = slot ? '<b>' + A.money(d.p - O.BAG_OFF) + '</b><s>' + A.money(d.p) + '</s>' : '<b>+ ' + A.money(d.p) + '</b>';
      return '<button type="button" class="sol-bar__addon" data-add="' + A.esc(d.h) + '" data-hc-el="addon-wallet-' + (slot ? 'bag' : 'trio') + '" aria-label="Add ' + A.esc(d.t) + '">' +
        '<img src="' + A.esc(A.img(d.i, 160)) + '" alt="" width="80" height="64" loading="lazy"><span>' + price + '</span></button>';
    }).join('') + '</div>' : '';
  }
  // shared with the quick view pair block (post-add status line; its own wallet rows stay)
  A.offerStatus = function (cart) {
    var st = O.status(O.tally(cart.items), cart, walletMin());
    return '<span class="sol-qv__tier' + (st.ok ? ' is-ok' : '') + '">' + st.text + '</span>';
  };
  function thumbs(cart) {
    var items = (cart.items || []).slice(0, 2).reverse(); // /cart.js lists newest first; 2 keep the mobile row roomy
    return items.map(function (it) {
      return '<img src="' + A.esc(A.img(it.image || '', 120)) + '" alt="" width="40" height="40">';
    }).join('') + '<span class="sol-bar__count">' + (cart.item_count || 0) + '</span>';
  }
  function paint(cart) {
    if (!cart) return;
    A.cart = cart; // last known cart (quick view skips wallets already in it)
    var t = O.tally(cart.items), st = O.status(t, cart, walletMin());
    var live = st.offer === 'trio' || t.wallets >= 3 ? 'trio' : (t.bags || st.offer === 'bag') ? 'bag' : '';
    cards.forEach(function (c) { c.classList.toggle('is-on', c.dataset.offer === live); });
    var count = cart.item_count || 0;
    bar.hidden = count < 1 || A.phase() !== 'live';
    root.classList.toggle('has-bar', !bar.hidden);
    if (bar.hidden) return;
    if (thumbsEl) thumbsEl.innerHTML = thumbs(cart);
    tEl.innerHTML = '<b>' + count + (count === 1 ? ' item' : ' items') + ' · ' + A.money((cart.total_price || 0) / 100) + '</b>' +
      '<small' + (st.ok ? ' class="sol-bar__ok"' : '') + '>' + st.text + '</small>';
    if (addEl) addEl.innerHTML = addOnRow(t, st);
  }
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(paint).catch(function () {});
    }, 150);
  }
  root.addEventListener('sol:added', function (e) {
    if (e.detail && e.detail.cart) paint(e.detail.cart); else refresh();
    setTimeout(function () { bar.classList.remove('is-pop'); void bar.offsetWidth; bar.classList.add('is-pop'); }, 600); // as the photo lands
  });
  if (thumbsEl) thumbsEl.addEventListener('click', function () {
    var icon = document.querySelector('.header-actions__cart-icon');
    if (icon && icon.offsetParent !== null) icon.click(); else location.href = '/cart';
  });
  root.addEventListener('sol:ended', function () { bar.hidden = true; root.classList.remove('has-bar'); });
  document.addEventListener('cart:update', refresh);
  refresh();
})();
